import { trackEvent } from 'vendor/google/gtm/gtmEventTracker';

export default () => {
    const flowboxContainer = document.getElementById('js-flowbox-flow');

    if (flowboxContainer) {
        flowboxContainer.addEventListener('click', (e) => {
            const flowboxPhoto = e.target.closest('img');

            if (flowboxPhoto) {
                trackEvent('Homepage', 'Flowbox', 'image');
            }
        });
    }
};
